import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, TaglineTitleContent, YouTubeVideo } from 'newComponents'
import stars from '../../images/_defaultStars/static-stars-legacy.jpeg'
import './styles.scss'

const FeatureBlock = (props) => {
  const { data } = props
  const { primary } = data
  const {
    content,
    image,
    badge,
    tagline,
    title,
    align_left: alignLeft,
    youtube_id: youtubeId,
    image_display: imgDisplay,
    has_slanted_bottom: isSlanted,
    background_option: bgOption,
    cta_text: ctaText,
    cta_url: ctaUrl
  } = primary

  // content checks
  const titleHtml = title?.html
  const taglineHtml = tagline?.html
  const contentHtml = content?.html
  const hasImage = image?.url
  const hasVideo = youtubeId?.text

  // apply classes
  const leftAlign = alignLeft ? 'align-left' : ''
  const isVideo = hasVideo ? 'has-video' : 'has-image'
  const imageDisplay = imgDisplay ? imgDisplay.toLowerCase() : ''
  const BGColor = bgOption ? bgOption.toLowerCase() : ''
  const slantedBottom = isSlanted ? 'slanted-bottom' : ''
  const ctas = ctaUrl.url ? { ctaText, ctaUrl } : null

  return (
    <OnVisible className={`feature-block-slice ${leftAlign} ${isVideo} ${imageDisplay} ${slantedBottom} ${BGColor}`}>
      <Section bgImage={stars}>
        <div className="feature-block-slice-text">
          <TaglineTitleContent
            className="feature-block-slice-content"
            title={titleHtml}
            tagline={taglineHtml}
            content={contentHtml}
            badge={badge}
            ctas={ctas}
            lightText
          />
        </div>
        {hasImage && <Image className="feature-block-slice-image" image={image} />}
        {hasVideo && <YouTubeVideo className="feature-block-slice-video" videoId={hasVideo} />}
      </Section>
    </OnVisible>
  )
}

export default FeatureBlock
